// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"db68393b","220":"e9c6fde4","225":"b261a260","576":"9c79f706","607":"bb4cdc09","823":"fa45c6fb"}[chunkId] + ".chunk.js";
};